import { useMemo } from 'react';

const AvailableLicenses = ['kitchenDisplay'] as const;
type License = (typeof AvailableLicenses)[number];

type LicenseTarget =
  | `${(typeof APP_CONFIG)['environment']}`
  | `${(typeof APP_CONFIG)['environment']}-${(typeof APP_CONFIG)['stack']}`
  | 'ALL';

const LicenseConfig: Record<License, LicenseTarget | LicenseTarget[]> = {
  kitchenDisplay: 'development-local',
};

export type Licenses = Record<License, boolean>;

export const useLicenses = (): Licenses => {
  const licenses = useMemo(() => {
    return Object.entries(LicenseConfig).reduce((acc, [license, target]) => {
      if (Array.isArray(target)) {
        acc[license as License] =
          target.includes(`${APP_CONFIG.environment}-${APP_CONFIG.stack}`) ||
          target.includes(APP_CONFIG.environment) ||
          target.includes('ALL');
      } else {
        acc[license as License] =
          target === 'ALL' ||
          target === APP_CONFIG.environment ||
          target === `${APP_CONFIG.environment}-${APP_CONFIG.stack}`;
      }

      return acc;
    }, {} as Licenses);
  }, []);

  return licenses;
};
